import http from './httpInstance'

// 请求皮肤主题
function getTheme () {
  return http({
    method: 'get',
    url: '/artemis-portal/artemis/theme'
  })
}

function getUserInfo () {
  return http({
    method: 'get',
    url: 'https://my-json-server.typicode.com/zimplexing/demo/userInfo'
  })
}

// 请求菜单列表
function getMenuList () {
  return http({
    method: 'get',
    url: '/artemis-portal/artemis/menuList'
  })
}

// 请求项目信息
function getProjectInfo (lan) {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/projectInfo?lan=${lan}`
  })
}

// 请求下载页文档列表
function getDownloadCategory () {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/download/category/search/condition',
    data: {
      pageNo: 1,
      pageSize: 10000
    }
  })
}

function getDownloadFiles (ids) {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/download/category/search/id',
    data: ids
  })
}

// 获取目录树
function getTree (data) {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/document/tree',
    data
  })
}

// 根据文档Id查询文档信息
function getDocById (data) {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/document/search/id',
    data
  })
}

// 根据分组id/name查询API
function getApiByGroupId (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/api/search/condition`,
    data
  })
}

// 根据分组id/name查询API
function getDocByName (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/document/search/tree`,
    data
  })
}

// 根据文档关联API分组Id查询文档信息
function getDocByGroupId (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/document/search/relatedGroupId`,
    data
  })
}

// 根据请求来源获取真实api请求path
function getApiHost () {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/document/apiHostInfo`,
    data: {}
  })
}

// 获取分组描述
function getGroup (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/group/search/id`,
    data
  })
}

export {
  getTheme,
  getUserInfo,
  getMenuList,
  getProjectInfo,
  getDownloadCategory,
  getDownloadFiles,
  getTree,
  getDocById,
  getApiByGroupId,
  getDocByName,
  getApiHost,
  getDocByGroupId,
  getGroup
}
